var React = require('react');

function Maximize (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9 21H3V15","stroke":"#8B929A","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3 21L10 14","stroke":"#8B929A","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M15 3H21V9","stroke":"#8B929A","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M21 3L14 10","stroke":"#8B929A","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Maximize.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Maximize;

Maximize.default = Maximize;
